import {
  Store,
  UtensilsCrossed,
  Clock3,
  CalendarDays,
  Truck,
  IndianRupee,
  BadgeCheck,
  ShieldCheck,
} from "lucide-react";

import "./ProviderCards.css";

function BusinessInfoCard({ provider }) {

  const business = provider.business || {};

  const businessDetails = [

    {
      icon: <Store size={18} />,
      label: "Business Name",
      value: business.businessName || "-",
    },

    {
      icon: <UtensilsCrossed size={18} />,
      label: "Food Type",
      value: business.foodType || "-",
    },

    {
      icon: <Clock3 size={18} />,
      label: "Working Hours",
      value: `${business.openingTime || "--"} - ${business.closingTime || "--"}`,
    },

    {
      icon: <Truck size={18} />,
      label: "Delivery Radius",
      value: `${business.deliveryRadius || 0} km`,
    },

    {
      icon: <IndianRupee size={18} />,
      label: "Minimum Order",
      value: `₹ ${Number(
        business.minimumOrder || 0
      ).toLocaleString("en-IN")}`,
    },

    {
      icon: <CalendarDays size={18} />,
      label: "Weekly Holiday",
      value: business.weeklyHoliday || "-",
    },

    {
      icon: <ShieldCheck size={18} />,
      label: "FSSAI Number",
      value: business.fssaiNumber || "Not Available",
    },

    {
      icon: <BadgeCheck size={18} />,
      label: "GST Number",
      value: business.gstNumber || "Not Available",
    },

  ];

  return (

    <div className="provider-card">

      <h3 className="card-title">

        Business Information

      </h3>

      <div className="info-list">

        {businessDetails.map((item, index) => (

          <div
            className="info-row"
            key={index}
          >

            <div className="info-label">

              {item.icon}

              <span>

                {item.label}

              </span>

            </div>

            <div className="info-value">

              {item.value}

            </div>

          </div>

        ))}

      </div>

    </div>

  );

}

export default BusinessInfoCard;